<template>
    <section id="features" class="section features-area ptb_100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-6">
                        <!-- Section Heading -->
                        <div class="section-heading text-center">
                            <h2>{{data.header}}</h2>
                            <p v-if="data.subheader" class="mt-4">{{data.subheader}}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div v-for="(feature, index) in data.features" :key="index" class="col-12 col-md-6 col-lg-4">
                        <!-- Icon Box -->
                        <div class="icon-box text-center p-4 wow fadeInUp" data-wow-duration="2s">
                            <!-- Featured Icon -->
                            <div class="featured-icon mb-3">
                                <span :class="feature.icon"></span>
                            </div>
                            <!-- Icon Text -->
                            <div class="icon-text">
                                <h3 class="mb-2">{{feature.title}}</h3>
                                <p>{{feature.text}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    props: ['data']
}
</script>
